import productCore from "../core/product.core";
import { BundleCombination, BundleCombinationItemWithInventory } from "../types/product";
import useBundleProductItems from "./useBundleProductItems.hook";

export default function useGetBundleSelectionInventory(bundleSelection: BundleCombination | undefined | null) {
  const { data: bundleItemProducts } = useBundleProductItems(bundleSelection);

  if (!bundleSelection || !bundleItemProducts || bundleItemProducts.length === 0) return undefined;
  if (!bundleItemProducts || bundleItemProducts.length === 0) return undefined;

  const bundleSelectionItemsWithInventory = bundleSelection.items.map<BundleCombinationItemWithInventory>((item) => {
    const targetProduct = bundleItemProducts.find((v) => v?.id === item.productId)!;

    return {
      ...item,
      inventory: productCore.getSimpleProductInventoryCount(targetProduct),
    };
  });

  return Math.min(...bundleSelectionItemsWithInventory.map((item) => item.inventory));
}
